// src/icons/globalIcons.tsx
import React, {SVGProps} from "react";

// On peut définir une interface pour typer nos props d’icône.
// (Optionnel : tu peux aussi utiliser React.SVGProps<SVGSVGElement> directement,
//  ou adapter selon tes préférences.)
export interface IconProps extends React.SVGProps<SVGSVGElement> {
    className?: string;
}

/**
 * FlowIcon
 */
export const FlowIcon: React.FC<IconProps> = ({className, ...props}) => (
    <svg
        {...props}
        className={className}
        fill="currentColor"
        viewBox="0 0 36 36"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
    >
        <polygon
            points="9.8 18.8 26.2 18.8 26.2 21.88 27.8 21.88 27.8 17.2 18.8 17.2 18.8 14 17.2 14 17.2 17.2 8.2 17.2 8.2 21.88 9.8 21.88 9.8 18.8"/>
        <path d="M14,23H4a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V25A2,2,0,0,0,14,23ZM4,31V25H14v6Z"/>
        <path d="M32,23H22a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H32a2,2,0,0,0,2-2V25A2,2,0,0,0,32,23ZM22,31V25H32v6Z"/>
        <path d="M13,13H23a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2H13a2,2,0,0,0-2,2v6A2,2,0,0,0,13,13Zm0-8H23v6H13Z"/>
        <rect x="0" y="0" width="36" height="36" fillOpacity="0"/>
    </svg>
);

/**
 * DuplicateIcon
 */
export const DuplicateIcon: React.FC<IconProps> = ({className, ...props}) => (
    <svg
        {...props}
        className={className}
        fill="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18 3H4C3.44772 3 3 3.44772 3 4V18C3 18.5523 2.55228 19 2 19C1.44772 19 1 18.5523 1 18V4C1 2.34315 2.34315 1 4 1H18C18.5523 1 19 1.44772 19 2C19 2.55228 18.5523 3 18 3Z"/>
        <path
            d="M13 11C13 10.4477 13.4477 10 14 10C14.5523 10 15 10.4477 15 11V13H17C17.5523 13 18 13.4477 18 14C18 14.5523 17.5523 15 17 15H15V17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17V15H11C10.4477 15 10 14.5523 10 14C10 13.4477 10.4477 13 11 13H13V11Z"/>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 5C21.6569 5 23 6.34315 23 8V20C23 21.6569 21.6569 23 20 23H8C6.34315 23 5 21.6569 5 20V8C5 6.34315 6.34315 5 8 5H20ZM20 7C20.5523 7 21 7.44772 21 8V20C21 20.5523 20.5523 21 20 21H8C7.44772 21 7 20.5523 7 20V8C7 7.44772 7.44772 7 8 7H20Z"
        />
    </svg>
);

/**
 * CardexIcon
 */
export const CardexIcon: React.FC<IconProps> = ({className, ...props}) => (
    <svg
        {...props}
        className={className}
        fill="currentColor"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4 4H3v1h2V2h1v20H5v-1H4v2h18V1H4zm3-2h14v20H7zM5 20H3v-1h1v-1h1zm0-6H3v-1h1v-1h1zm0-6H3V7h1V6h1zm0 3H3v-1h1V9h1zm0 6H3v-1h1v-1h1zm10.5-5h-3A3.504 3.504 0 0 0 9 15.5V18h10v-2.5a3.504 3.504 0 0 0-3.5-3.5zm2.5 5h-8v-1.5a2.503 2.503 0 0 1 2.5-2.5h3a2.503 2.503 0 0 1 2.5 2.5zm-4-6a3 3 0 1 0-3-3 3.003 3.003 0 0 0 3 3zm0-5a2 2 0 1 1-2 2 2.002 2.002 0 0 1 2-2z"/>
        <path fill="none" d="M0 0h24v24H0z"/>
    </svg>
);

/**
 * WhatsappIcon
 */
export const WhatsappIcon: React.FC<IconProps> = ({className, ...props}) => (
    <svg
        {...props}
        className={className}
        fill="currentColor"
        viewBox="0 0 308 308"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458C233.168,179.508,230.845,178.393,227.904,176.981z"/>
        <path
            d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867C276.546,215.678,222.799,268.994,156.734,268.994z"/>
    </svg>
);

/**
 * MessengerIcon — logo officiel Facebook Messenger (bubble + lightning)
 */
export const MessengerIcon: React.FC<IconProps> = ({className, ...props}) => (
    <svg
        {...props}
        className={className}
        fill="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M12 2C6.477 2 2 6.145 2 11.259c0 2.913 1.456 5.515 3.732 7.218V22l3.33-1.83c.892.249 1.854.388 2.938.388 5.523 0 10-4.145 10-9.259S17.523 2 12 2zm1.001 13.367l-2.548-2.717-4.953 2.717L10.954 9.564l2.609 2.718 4.89-2.718-5.452 5.803z"/>
    </svg>
);

/**
 * InstagramIcon — logo officiel Instagram (camera square)
 */
export const InstagramIcon: React.FC<IconProps> = ({className, ...props}) => (
    <svg
        {...props}
        className={className}
        fill="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
    </svg>
);

export const EndPageIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="800px"
        height="800px"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M3 1.773l15 10.23L3 22.226zM20 22h1V2h-1z" />
        <path fill="none" d="M0 0h24v24H0z" />
    </svg>
);

/**
 * ProductsIcon
 */
export const ProductsIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg
        {...props}
        className={className}
        fill="currentColor"
        viewBox="0 0 32 32"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M31.739 8.875c-0.186-0.264-0.489-0.422-0.812-0.422h-3.117l-6.41-5.463c-0.78-0.78-2.047-0.781-2.828 0l-6.302 5.463h-2.566l-1.607-5.54c-0.63-2.182-2.127-2.417-2.741-2.417h-4.284c-0.549 0-0.993 0.445-0.993 0.993s0.445 0.993 0.993 0.993h4.283c0.136 0 0.549 0 0.831 0.974l5.527 20.311c0.12 0.428 0.511 0.724 0.956 0.724h13.499c0.419 0 0.793-0.262 0.934-0.657l4.758-14.053c0.11-0.304 0.064-0.643-0.122-0.907zM19.986 4.404l4.751 4.050h-9.504zM25.47 22.506h-12.046l-3.161-12.066h19.253zM23.5 26.504c-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5 2.5-1.119 2.5-2.5c0-1.381-1.119-2.5-2.5-2.5zM14.5 26.504c-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5 2.5-1.119 2.5-2.5c0-1.381-1.119-2.5-2.5-2.5z"/>
    </svg>
);

/**
 * ProductsCategoriesIcon
 */
export const ProductsCategoriesIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg
        {...props}
        className={className}
        fill="currentColor"
        viewBox="0 0 64 64"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M9.89,30.496c-1.14,1.122-1.784,2.653-1.791,4.252c-0.006,1.599,0.627,3.135,1.758,4.266c3.028,3.028,7.071,7.071,10.081,10.082c2.327,2.326,6.093,2.349,8.448,0.051c5.91-5.768,16.235-15.846,19.334-18.871c0.578-0.564,0.905-1.338,0.905-2.146c0-4.228,0-17.607,0-17.607l-17.22,0c-0.788,0-1.544,0.309-2.105,0.862c-3.065,3.018-13.447,13.239-19.41,19.111Zm34.735-15.973l0,11.945c0,0.811-0.329,1.587-0.91,2.152c-3.069,2.981-13.093,12.718-17.485,16.984c-1.161,1.127-3.012,1.114-4.157-0.031c-2.387-2.386-6.296-6.296-8.709-8.709c-0.562-0.562-0.876-1.325-0.872-2.12c0.003-0.795,0.324-1.555,0.892-2.112c4.455-4.373,14.545-14.278,17.573-17.25c0.561-0.551,1.316-0.859,2.102-0.859c3.202,0,11.566,0,11.566,0Zm-7.907,2.462c-1.751,0.015-3.45,1.017-4.266,2.553c-0.708,1.331-0.75,2.987-0.118,4.356c0.836,1.812,2.851,3.021,4.882,2.809c2.042-0.212,3.899-1.835,4.304-3.896c0.296-1.503-0.162-3.136-1.213-4.251c-0.899-0.953-2.18-1.548-3.495-1.57c-0.031-0.001-0.062-0.001-0.094-0.001Zm0.008,2.519c1.105,0.007,2.142,0.849,2.343,1.961c0.069,0.384,0.043,0.786-0.09,1.154c-0.393,1.079-1.62,1.811-2.764,1.536c-1.139-0.274-1.997-1.489-1.802-2.67c0.177-1.069,1.146-1.963,2.27-1.981c0.014,0,0.029,0,0.043,0Z"/>
        <path d="M48.625,13.137l0,4.001l3.362,0l0,11.945c0,0.811-0.328,1.587-0.909,2.152c-3.069,2.981-13.093,12.717-17.485,16.983c-1.161,1.128-3.013,1.114-4.157-0.03l-0.034-0.034l-1.016,0.993c-0.663,0.646-1.437,1.109-2.259,1.389l1.174,1.174c2.327,2.327,6.093,2.35,8.447,0.051c5.91-5.768,16.235-15.845,19.335-18.87c0.578-0.565,0.904-1.339,0.904-2.147c0-4.227,0-17.607,0-17.607l-7.362,0Z"/>
    </svg>
);

/**
 * CatalogueIcon
 */
export const CatalogueIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg
        {...props}
        className={className}
        fill="currentColor"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
    >
        <path d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm1.5.5A.5.5 0 0 1 1 13V6a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13z" />
    </svg>
);

/**
 * ServiceIcon
 */
export const ServiceIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg
        {...props}
        className={className}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.91}
        strokeMiterlimit={10}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
    >
        <polygon points="22.5 22.5 1.5 22.5 1.5 20.59 2.46 18.68 21.55 18.68 22.5 20.59 22.5 22.5" />
        <path d="M11.75,5.32h.49a9.3,9.3,0,0,1,9.3,9.3v.25a0,0,0,0,1,0,0H2.45a0,0,0,0,1,0,0v-.25A9.3,9.3,0,0,1,11.75,5.32Z" />
        <line x1="12" y1="1.5" x2="12" y2="5.32" />
        <line x1="9.14" y1="1.5" x2="14.86" y2="1.5" />
        <rect x="5.32" y="14.86" width="13.36" height="3.82" />
    </svg>
);

/**
 * SaveIcon - Style Plein
 */
export const SaveIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg
        {...props}
        className={className}
        viewBox="0 0 24 24"
        fill="currentColor" // Utilise la couleur du texte
        stroke="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.1716 1C18.702 1 19.2107 1.21071 19.5858 1.58579L22.4142 4.41421C22.7893 4.78929 23 5.29799 23 5.82843V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H18.1716ZM4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H5V15C5 13.3431 6.34315 12 8 12H16C17.6569 12 19 13.3431 19 15V21H20C20.5523 21 21 20.5523 21 20V6.82843C21 6.29799 20.7893 5.78929 20.4142 5.41421L18.5858 3.58579C18.2107 3.21071 17.702 3 17.1716 3H17V5C17 6.65685 15.6569 8 14 8H10C8.34315 8 7 6.65685 7 5V3H4ZM17 21V15C17 14.4477 16.5523 14 16 14H8C7.44772 14 7 14.4477 7 15V21H17ZM9 3H15V5C15 5.55228 14.5523 6 14 6H10C9.44772 6 9 5.55228 9 5V3Z"
        />
    </svg>
);

/**
 * MoveIcon - Style Contour
 */
export const MoveIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg
        {...props}
        className={className}
        viewBox="0 0 24 24"
        fill="none" // Ne remplit pas
        stroke="currentColor" // Utilise la couleur du texte pour le contour
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 3V9M12 3L9 6M12 3L15 6M12 15V21M12 21L15 18M12 21L9 18M3 12H9M3 12L6 15M3 12L6 9M15 12H21M21 12L18 9M21 12L18 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/**
 * TrashIcon
 */
export const TrashIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg
        {...props}
        className={className}
        viewBox="0 0 24 24"
        fill="currentColor" // Assure la coloration par CSS
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M8 1.5V2.5H3C2.44772 2.5 2 2.94772 2 3.5V4.5C2 5.05228 2.44772 5.5 3 5.5H21C21.5523 5.5 22 5.05228 22 4.5V3.5C22 2.94772 21.5523 2.5 21 2.5H16V1.5C16 0.947715 15.5523 0.5 15 0.5H9C8.44772 0.5 8 0.947715 8 1.5Z" />
        <path d="M3.9231 7.5H20.0767L19.1344 20.2216C19.0183 21.7882 17.7135 23 16.1426 23H7.85724C6.28636 23 4.98148 21.7882 4.86544 20.2216L3.9231 7.5Z" />
    </svg>
);

/**
 * ArrowUpIcon - Style Contour
 */
export const ArrowUpIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg
        {...props}
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 20V4M12 4L18 10M12 4L6 10"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/**
 * RoomIcon - Lit / Chambre
 */
export const RoomIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg
        {...props}
        className={className}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
    >
        <path
            d="M3 21V7a1 1 0 0 1 1-1h4a2 2 0 0 1 2 2v2h10a2 2 0 0 1 2 2v9"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3 16h18"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="7" cy="10.5" r="1.5" />
    </svg>
);

/**
 * ExpandIcon - Style Contour
 */
export const ExpandIcon: React.FC<IconProps> = ({ className, ...props }) => (
    <svg
        {...props}
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4 9V5.6C4 5.03995 4 4.75992 4.10899 4.54601C4.20487 4.35785 4.35785 4.20487 4.54601 4.109C4.75992 4 5.03995 4 5.6 4L9 4M4 15V18.4C4 18.9601 4 19.2401 4.10899 19.454C4.20487 19.6422 4.35785 19.7951 4.54601 19.891C4.75992 20 5.03995 20 5.6 20L9 20M15 4H18.4C18.9601 4 19.2401 4 19.454 4.10899C19.6422 4.20487 19.7951 4.35785 19.891 4.54601C20 4.75992 20 5.03995 20 5.6V9M20 15V18.4C20 18.9601 20 19.2401 19.891 19.454C19.7951 19.6422 19.6422 19.7951 19.454 19.891C19.2401 20 18.9601 20 18.4 20H15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

